import { useBlockFlags } from '@ContractBuilder/modules/block/context/context';
import { ctxIsPDF } from '@ContractBuilder/rules/block/is-ctx';
import { useEntityStore } from '@ContractBuilder/store';
import type { EntityData } from '@domain/types/entity';
import { useDocumentLocation } from '@hooks/useDocumentLocation';
import { get } from 'lodash-es';

import { InlineAttachment } from '../views/InlineAttachment';

const getAttachment = (
  submission: EntityData,
  endorsementParent: EntityData | undefined,
  isEndorsementView: boolean,
  blockId: string,
) => {
  const submissionAttachments = get(submission, 'attachments', []);
  const submissionAttachment = submissionAttachments.find((attachment) => attachment.block_id === blockId);

  if (!isEndorsementView) {
    return submissionAttachment;
  }

  const parentAttachments = get(endorsementParent, 'attachments', []);
  const endorsementParentAttachment = parentAttachments.find((attachment) => attachment.block_id === blockId);

  return submissionAttachment ?? endorsementParentAttachment;
};

export const InlineAttachmentController = () => {
  const {
    block: { id: blockId },
    context,
  } = useBlockFlags();
  const isPDFRender = ctxIsPDF(context);

  const { isEndorsementView } = useDocumentLocation();
  const { submission, endorsementParent } = useEntityStore(({ submission, endorsementParent }) => ({
    submission,
    endorsementParent,
  }));

  if (!submission) {
    return null;
  }

  const attachment = getAttachment(submission, endorsementParent, isEndorsementView, blockId);

  if (!attachment) {
    return null;
  }

  return <InlineAttachment attachment={attachment} isPDFRender={isPDFRender} showBlockActions />;
};
